import { ChatState, ChatAction } from './types'

export const initialChatState: ChatState = {
  // Initialization
  initStatus: 'idle',
  initError: undefined,
  
  // Streaming
  streamStatus: 'idle',
  streamError: undefined,
  requestId: undefined,
  
  // Conversation data
  currentConversationId: undefined,
  conversationTitle: '',
  messages: [],
  streamingMessage: '',
  
  // Input
  inputValue: '',
  tags: []
}

export function chatReducer(state: ChatState, action: ChatAction): ChatState {
  switch (action.type) {
    case 'INIT_START':
      return {
        ...state,
        initStatus: 'loading',
        initError: undefined
      }
      
    case 'INIT_SUCCESS':
      return {
        ...state,
        initStatus: 'ready',
        initError: undefined,
        currentConversationId: action.payload.conversation.conversation_id,
        conversationTitle: action.payload.conversation.title || 'Untitled Conversation',
        messages: action.payload.conversation.messages
      }
      
    case 'INIT_ERROR':
      return {
        ...state,
        initStatus: 'error',
        initError: action.error
      }
      
    case 'SEND_START':
      return {
        ...state,
        streamStatus: 'sending',
        streamError: undefined,
        requestId: action.payload.requestId,
        streamingMessage: ''
      }
      
    case 'STREAM_CHUNK':
      return {
        ...state,
        streamStatus: 'streaming',
        streamingMessage: state.streamingMessage + action.payload.chunk
      }
      
    case 'STREAM_COMPLETE':
      return {
        ...state,
        streamStatus: 'idle',
        streamingMessage: '',
        requestId: undefined,
        messages: [
          ...state.messages,
          {
            message_id: Date.now().toString(),
            content: action.payload.fullResponse,
            role: 'assistant',
            timestamp: Date.now()
          }
        ]
      }
      
    case 'STREAM_ERROR':
      return {
        ...state,
        streamStatus: 'error',
        streamError: action.error,
        streamingMessage: '',
        requestId: undefined,
        messages: [
          ...state.messages,
          {
            message_id: Date.now().toString(),
            content: 'Sorry, I encountered an error. Please try again.',
            role: 'assistant',
            timestamp: Date.now()
          }
        ]
      }
      
    case 'ADD_USER_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, action.payload]
      }
      
    case 'SET_INPUT':
      return {
        ...state,
        inputValue: action.payload
      }
      
    case 'SET_TAGS':
      return {
        ...state,
        tags: action.payload
      }
      
    case 'CLEAR_INPUT':
      return {
        ...state,
        inputValue: '',
        tags: []
      }
      
    case 'RESET_CONVERSATION':
      return {
        ...state,
        initStatus: 'idle',
        streamStatus: 'idle',
        currentConversationId: undefined,
        conversationTitle: '',
        messages: [],
        streamingMessage: '',
        inputValue: '',
        tags: [],
        initError: undefined,
        streamError: undefined,
        requestId: undefined
      }
      
    default:
      return state
  }
} 